<script>
  import { apiFetch } from "../../lib/api.js";
  import { user } from "../../stores/user";
  import { BASE_URL } from "../../stores/BASE_URL";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  export let id_usuario = 0;

  let isLoading = true;
  let isAdding = false;

  let redes = [];
  let ip = "0.0.0.0";

  let acciones = false;

  const getRedesAutorizadas = async () => {
    const response = await apiFetch(`${BASE_URL}usuario.php?action=getRedesAutorizadas&id=${id_usuario}`);
    const resp = await response.json();
    redes = resp.data;
    isLoading = false;
  };

  const addRed = async () => {
    isAdding = true;
    const formData = new FormData();
    formData.append("id_usuario", id_usuario);
    formData.append("ip", ip);
    formData.append("action", "addRed");
    formData.append("session_id_usuario", $user.idUsuario);

    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: formData,
    });

    const resp = await response.json();
    if (resp.status == "success") {
      getRedesAutorizadas();
    }
    isAdding = false;
  };

  const deleteRed = async (id) => {
    const formData = new FormData();
    formData.append("id_usuario", id_usuario);
    formData.append("id", id);
    formData.append("action", "deleteRed");
    formData.append("session_id_usuario", $user.idUsuario);

    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: formData,
    });

    const resp = await response.json();
    if (resp.status == "success") {
      getRedesAutorizadas();
    }
  };

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true });
    }

    if ($user.rol == "administrador" || $user.rol == "operaciones") {
      acciones = true;
    }
  });

  getRedesAutorizadas();
</script>

<div>
  {#if acciones}
    <div class="d-flex gap-2 mb-2">
      <input type="text" class="form-control" placeholder="0.0.0.0" bind:value={ip} />
      {#if isAdding}
        <button class="btn btn-primary" disabled>Agregando...</button>
      {:else}
        <button class="btn btn-primary" on:click={addRed}>Agregar</button>
      {/if}
    </div>
  {/if}
  <div class="d-flex flex-wrap gap-2">
    {#if !isLoading}
      {#each redes as ip}
        <div class="btn-group btn-group-sm" role="group" aria-label="Large button group">
          <button type="button" class="btn btn-secondary btn-sm" disabled>{ip.ip}</button>
          <button type="button" class="btn btn-secondary btn-sm" on:click={() => deleteRed(ip.id)}><i class="bi bi-x"></i></button>
        </div>
      {/each}
    {/if}
  </div>
</div>
